import{typedModal}from"../../utils/typedModals";const CartModalEvents=typedModal();export default CartModalEvents;